import React from 'react';
import {Avatar, Button, Card, Typography, Spin} from 'antd';
import {UserOutlined} from '@ant-design/icons';
import {bindingTeams, getBindingStatus} from "../../apis/reverse-proxy";
import { getUserInfo,getToken } from "../../utils/cookies";
import useTeamsBinding from './use-teams-binding';
const {Text} = Typography;

const TeamsBinding = () => {
    const {
        username,
        handleBind,
        isBound,
        loading,
        logout,
        handleClose,
    } = useTeamsBinding({
        getToken:getToken,
        getUserInfo:getUserInfo,
        getBindingStatus:getBindingStatus,
        bindingTeams:bindingTeams,
        state: new URLSearchParams(window.location.search).get('state')
    });

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: '#F7FAFC'
        }}>
            {loading ? (
                <Spin size="large" />
            ) : (
                isBound ? (
                    <Card style={{
                        width: 420,
                        textAlign: 'center',
                        borderRadius: 12,
                        boxShadow: '0 6px 15px rgba(0, 0, 0, 0.1)',
                        border: '1px solid #D1D5DB'
                    }}>
                        <div style={{marginBottom: 24}}>
                            <Typography.Title level={2} style={{color: '#007ACC'}}>DotZero</Typography.Title>
                        </div>
                        <Avatar size={72} icon={<UserOutlined/>} style={{marginBottom: 24, backgroundColor: '#007ACC'}}/>
                        <Text style={{display: 'block', marginBottom: 16, fontSize: '16px', color: '#374151'}}>您已經綁定帳號</Text>
                        <Text style={{display: 'block', marginBottom: 24, fontSize: '14px', color: '#6B7280'}}>您目前登入的帳號：<strong>{username}</strong></Text>
                        <Button type="default" onClick={handleClose} size="large" block
                                style={{borderColor: '#D1D5DB', marginBottom: 12}}>
                            關閉
                        </Button>
                    </Card>
                ) : (
                    <Card style={{
                        width: 420,
                        textAlign: 'center',
                        borderRadius: 12,
                        boxShadow: '0 6px 15px rgba(0, 0, 0, 0.1)',
                        border: '1px solid #D1D5DB'
                    }}>
                        <div style={{marginBottom: 24}}>
                            <Typography.Title level={2} style={{color: '#007ACC'}}>DotZero</Typography.Title>
                        </div>
                        <Avatar size={72} icon={<UserOutlined/>} style={{marginBottom: 24, backgroundColor: '#007ACC'}}/>
                        <Text
                            style={{display: 'block', marginBottom: 16, fontSize: '16px', color: '#374151'}}>確認帳號綁定</Text>
                        <Text style={{display: 'block', marginBottom: 24, fontSize: '14px', color: '#6B7280'}}>您目前登入的帳號：<strong>{username}</strong></Text>
                        <Text style={{display: 'block', marginBottom: 24, fontSize: '14px', color: '#6B7280'}}>是否要將此帳號與 工廠哈識奇 綁定？</Text>
                        <Button type="primary" size="large" block
                                onClick={handleBind}
                                style={{backgroundColor: '#005A9E', borderColor: '#005A9E', marginBottom: 12}}>
                            確認綁定
                        </Button>
                        <Button type="default" onClick={logout} size="large" block
                                style={{borderColor: '#D1D5DB', marginBottom: 12}} disabled={isBound}>
                            更換帳號
                        </Button>
                    </Card>
                )
            )}
        </div>
    );
};

export default TeamsBinding;
